import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;
	place-items: center;

	div {
		width: 100%;
	}
`;
